
/**
 * returns the given date in the following format: 
 * mmm dd, yyyy (e.g. Jan 1, 2023)
 * if the given value is not a valid date, returns the value as-is
 * if the given value is null/undefined, returns '—'
 */

export const formatDateShortMonthDayYear = (value) => {
    if (!value) {
        return '—';
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }

    return parsed.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};
